<template>
	<svg
		id="order_completed"
		width="128.777832"
		height="128.777832"
		viewBox="0 0 128.778 128.778"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		
	>
		<defs>
			<filter
				id="filter_395_1636_dd"
				x="0.000000"
				y="0.000000"
				width="128.777832"
				height="128.777832"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feGaussianBlur in="BackgroundImage" stdDeviation="1.33333" />
				<feComposite in2="SourceAlpha" operator="in" result="effect_backgroundBlur_1" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect_backgroundBlur_1" result="shape" />
			</filter>
		</defs>
		<g filter="url(#filter_395_1636_dd)">
			<circle id="Фон" cx="64.388916" cy="64.388916" r="64.388885" fill="#000000" fill-opacity="0.400000" />
		</g>
		<circle
			id="Ellips8"
			cx="64.388916"
			cy="64.388916"
			r="59.500000"
			stroke="#FF6D2E"
			stroke-opacity="1.000000"
			stroke-width="3.000000"
			stroke-dasharray="5 2"
		/>
		<path
			id="path"
			d="M96.51 42.31L96.51 42.28C97.5 41.29 99.06 41.29 100.05 42.29C101.03 43.28 101.03 44.84 100.04 45.82L100.01 45.82L96.51 42.31ZM32.15 69.85L32.12 69.85C31.13 68.87 31.12 67.31 32.11 66.32C33.1 65.33 34.66 65.32 35.65 66.31L35.65 66.34L32.15 69.85Z"
			fill="#000000"
			fill-opacity="0"
			fill-rule="nonzero"
		/>
		<path
			id="path1"
			d="M98.27 44.05L54.01 88.11L33.88 68.08"
			stroke="#FF6D2E"
			stroke-opacity="1.000000"
			stroke-width="5.000000"
			stroke-linejoin="round"
			stroke-linecap="round"
		/>
	</svg>
</template>
